import { render } from "./App.vue?vue&type=template&id=d2635c42"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d2635c42&lang=less"

import exportComponent from "E:\\05projects\\fullstack\\who-clicked-clock\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__